export enum UserTableActionType {
  ADD_USER = 'ADD_USER',
  BLOCK_ALL_USERS = 'BLOCK_ALL_USERS',
  SPY_USER = 'SPY_USER',
}
